//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    today_fetchAll as fetchAll,
    checkedTotal,
    _ORDER_TYPE,
    _ORDER_TYPE_COLOR,
    _ORDER_TYPE_CHECKED_KEYS,
    _ORDER_STATUS,
    _ORDER_STATUS_COLOR
} from '@/apis/order'

import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [],
                orderType: [],
                checkedTotal:0,
            },
            searchQuery: {
                status: "",
                orderNo: "",
                contactName: "",
                contactPhone: "",
                venueCode: "",
                fieldCode: "",
                orderType: "",
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '訂單類型', key: 'orderType', scopedSlots: { customRender: 'orderTypeSlot' }, width: 120 },
            { title: '編號', dataIndex: 'orderNo', key: 'orderNo', width: 300 },
            { title: '報到時間', dataIndex: 'verifyTime', key: 'verifyTime', width: 180, },
            { title: '消費點數', dataIndex: 'consumedPoints', key: 'consumedPoints', width: 120 },
            { title: '客戶姓名', dataIndex: 'memberName', key: 'memberName', width: 180 },
            { title: '客戶手機', dataIndex: 'memberPhone', key: 'memberPhone', width: 180 },
            // { title: '報到狀態', key: 'checkState', scopedSlots: { customRender: 'checkStatusSlot' }, width: 160 },
            { title: '品牌', dataIndex: 'mchName', key: 'mchName', width: 180 },
            { title: '場館', dataIndex: 'venueName', key: 'venueName', width: 180 },
            { title: '場地', dataIndex: 'fieldName', key: 'fieldName', width: 180 },
            { title: '場次', dataIndex: 'timeSlotName', key: 'timeSlotName', width: 180 },
            { title: '日期', key: 'date', scopedSlots: { customRender: 'dateSlot' }, width: 180 },
            { title: '聯絡人', dataIndex: 'contactName', key: 'contactName', width: 180 },
            { title: '聯絡人電話', dataIndex: 'contactPhone', key: 'contactPhone', width: 180 }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        moment,
        onChangeOrderType(value) {
            let orderType = value.target.value;
            this.onPageLoad()
        },
        onChangeDate(value) {
            if (value.length > 0) {
                this.searchQuery.sDate = value[0].format('YYYY-MM-DD HH:mm')
                this.searchQuery.eDate = value[1].format('YYYY-MM-DD HH:mm')
            } else { 
                this.searchQuery.sDate = "";
                this.searchQuery.eDate = "";
            }
            
        },

        async onPageConfig() {
            try {
                let _order_type = [];

                const res1 = await checkedTotal({ sDate: moment().format('YYYY-MM-DD 00:00:00'), eDate: moment().format('YYYY-MM-DD 23:59:59') });
                const _checkedTotal = res1.data;
                this.config.checkedTotal = _checkedTotal['totalCount'] !== undefined ? _checkedTotal['totalCount'] : 0;

                Object.keys(_ORDER_TYPE).forEach(value => {
                    _order_type.push({
                        id: value,
                        name: _ORDER_TYPE[value]
                            + "(" +
                            (
                            _ORDER_TYPE_CHECKED_KEYS[value] !== undefined && _checkedTotal[_ORDER_TYPE_CHECKED_KEYS[value]] !== undefined ? _checkedTotal[_ORDER_TYPE_CHECKED_KEYS[value]] : 0)

                            + ")"
                    })
                });
                this.config.orderType = _order_type;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = this.parseRecords(res.data.records);
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        parseRecords(records) {
            const _this = this;
            records.forEach(order => {
                order.order_type_text = _this._getOrderTypeText(order.orderType);
                order.order_type_color = _this._getOrderTypeTextColor(order.orderType);
            })

            return records;
        },
        _getOrderStatusText(value) {
            return _ORDER_STATUS[value] !== undefined ? _ORDER_STATUS[value] : '';
        },
        _getOrderStatusColor(value) {
            return _ORDER_STATUS_COLOR[value] !== undefined ? _ORDER_STATUS_COLOR[value] : '';
        },
        _getOrderTypeText(value) {
            return _ORDER_TYPE[value] !== undefined ? _ORDER_TYPE[value] : '-';
        },
        _getOrderTypeTextColor(value) {
            return _ORDER_TYPE_COLOR[value] !== undefined ? _ORDER_TYPE_COLOR[value] : '-';
        },
        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        }
    }
}
